import React, { useState } from "react";
import styles from "./OrderHistory.module.css";
import { Table } from "antd";
import SubmitButton from "../../../../../components/submitButton/SubmitButton";
import { useNavigate } from "react-router-dom";

const OrderHistoryComponent = () => {
  const navigate = useNavigate();
  const columns = [
    {
      title: "Order ID",
      dataIndex: "OrderID",
      key: "OrderID",
    },
    {
      title: "Order Date",
      dataIndex: "OrderDate",
      key: "OrderDate",
    },
    {
      title: "Order by",
      key: "OrderBy",
      dataIndex: "OrderBy",
    },

    {
      title: "Fulfillment Status",
      key: "FulfillmentStatus",
      dataIndex: "FulfillmentStatus",
    },
    {
      title: "Due Date",
      key: "DueDate",
      dataIndex: "DueDate",
    },
    {
      title: "",
      key: "action",
      dataIndex: "Button",
      render: (text, record) => record.Button,
    },
  ];

  const data = [
    {
      OrderID: "153534",
      OrderDate: "Aug 13, 2025 ",
      OrderBy: "Chris Glasser",
      FulfillmentStatus: "Delivered",
      DueDate: "Aug 15, 2025 ",
      Button: (
        <SubmitButton
          title={"View"}
          onClick={() => navigate("/AdminProductJourney")}
          primary
          btnClass={styles.actionBtn}
        // onClick={handleSubmit}
        />
      ),
    },
    {
      OrderID: "153534",
      OrderDate: "Aug 13, 2025 ",
      OrderBy: "Chris Glasser",
      FulfillmentStatus: "Delivered",
      DueDate: "Aug 15, 2025 ",
      Button: (
        <SubmitButton
          title={"View"}
          primary
          onClick={() => navigate("/AdminProductJourney")}
          btnClass={styles.actionBtn}
        // onClick={handleSubmit}
        />
      ),
    },
    {
      OrderID: "153534",
      OrderDate: "Aug 13, 2025 ",
      OrderBy: "Chris Glasser",
      FulfillmentStatus: "Delivered",
      DueDate: "Aug 15, 2025 ",

      Button: (
        <SubmitButton
          title={"View"}
          primary
          onClick={() => navigate("/AdminProductJourney")}
          btnClass={styles.actionBtn}
        // onClick={handleSubmit}
        />
      ),
    },
    {
      OrderID: "153534",
      OrderDate: "Aug 13, 2025 ",
      OrderBy: "Chris Glasser",
      FulfillmentStatus: "Delivered",
      DueDate: "Aug 15, 2025 ",

      Button: (
        <SubmitButton
          title={"View"}
          primary
          onClick={() => navigate("/AdminProductJourney")}
          btnClass={styles.actionBtn}
        // onClick={handleSubmit}
        />
      ),
    },
    {
      OrderID: "153534",
      OrderDate: "Aug 13, 2025 ",
      OrderBy: "Chris Glasser",
      FulfillmentStatus: "Delivered",
      DueDate: "Aug 15, 2025 ",

      Button: (
        <SubmitButton
          title={"View"}
          onClick={() => navigate("/AdminProductJourney")}
          primary
          btnClass={styles.actionBtn}
        // onClick={handleSubmit}
        />
      ),
    },
  ];

  return (
    <div className={styles.mainCont}>
      <div className={styles.TableDiv}>
        <Table
          scroll={{ x: true }}
          columns={columns}
          dataSource={data}
          pagination={false}
          rowKey="No"
        />
      </div>
    </div>
  );
};

export default OrderHistoryComponent;
